import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AudienceCriteria } from "entities/domain/audience";
import { RootState } from "redux/store";

// All contact entity data is managed by tanstack-query cache.
// This is an internal refactor - no API contract changes.

export interface ContactsState {
  shouldUseCriteriaForSearch: boolean;
  advancedFilter: AudienceCriteria | null;
}

const initialState: ContactsState = {
  shouldUseCriteriaForSearch: false,
  advancedFilter: null,
};

export const contactsSelector = (state: RootState) => state.contacts;

const contactsSlice = createSlice({
  name: "contacts",
  initialState,
  reducers: {
    setAdvancedFilter: (
      state,
      action: PayloadAction<AudienceCriteria | null>
    ) => {
      state.advancedFilter = action.payload;
    },
    setShouldUseCriteriaForSearch: (state, action: PayloadAction<boolean>) => {
      state.shouldUseCriteriaForSearch = action.payload;
    },
    resetStore: (state) => {
      state.shouldUseCriteriaForSearch = false;
      state.advancedFilter = null;
    },
  },
});

export const { setAdvancedFilter, setShouldUseCriteriaForSearch, resetStore } =
  contactsSlice.actions;
export const contactsSliceActions = contactsSlice.actions;
export default contactsSlice.reducer;
